import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { TrialLockoutModal as SharedTrialLockoutModal } from '@discover-frontend/components';

import { addToast } from 'src/actions/ToastActions';

export const TrialLockoutModal: FC = () => {
  const dispatch = useDispatch();

  return (
    <SharedTrialLockoutModal
      onNotifySuccess={(message) =>
        dispatch(addToast({ status: 'success', message }))
      }
      onNotifyError={(message) =>
        dispatch(addToast({ status: 'error', message }))
      }
    />
  );
};
